import { useEffect } from "react";


import { PremiumPaywallSignModes, AuthStepsEnum } from "../../../../../global/paywall/paywallInterfaces";
import { getAuthHookFactory } from "../../../../../global/paywall/useAuth";
import { PremiumPayWallMobileSignupEmail as PremiumCalcalistPaywallMobileSignupEmail } from "./signup/premiumCalcalistPaywallMobileSignupEmail";
import { PremiumPaywallMobileSignupPassword as PremiumCalcalistPaywallMobileSignupPassword } from "./signup/premiumCalcalistPaywallMobileSignupPassword";
import { PremiumPayWallMobileSignupConfirmTerms as PremiumCalcalistPaywallMobileSignupConfirmTerms } from "./signup/premiumCalcalistPaywallMobileSignupConfirmTerms";
import PremiumCalcalistPaywallMobileSignupFinish from "./signup/premiumCalcalistPaywallMobileSignupFinish";
import { LegalLink } from "./premiumCalcalistPaywallMobile";


interface PremiumCalcalistPaywallMobileSignUpProps {
  email: string
  password: string
  agreesTerms: boolean
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  setIsRedirecting: (isRedirect: boolean) => void;
  legalLinks: { terms: LegalLink; privacy: LegalLink };
}

export const PremiumCalcalistPaywallMobileSignUp = (props: PremiumCalcalistPaywallMobileSignUpProps) => {

  const { email, setEmail, password, setPassword, setMode, agreesTerms, setAgreesTerms, setIsRedirecting, legalLinks } = props

  const {
    authError,
    step,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    resetAuth,
    setAuthError,
  } = getAuthHookFactory("signup")();

  const sendMail = () => {
    sendEmailOrPhoneForLogin(email, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
    setAgreesTerms(false)
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  useEffect(() => {
    if (/^\d+$/.test(email)) {
      setEmail('');
    }
  }, []);


  switch (step) {
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumCalcalistPaywallMobileSignupEmail
          email={email}
          agreesTerms={agreesTerms}
          setEmail={setEmail}
          setAgreesTerms={setAgreesTerms}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          legalLinks={legalLinks}
          setAuthError={setAuthError}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumCalcalistPaywallMobileSignupPassword
          email={email}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
        />
      )

    case AuthStepsEnum.CONFIRM_TERMS:
      return (
        <PremiumCalcalistPaywallMobileSignupConfirmTerms
          resetAuth={onReset}
          thirdPartyLogin={onThirdPartyLogin}
          legalLinks={legalLinks}
        />
      )

    case AuthStepsEnum.FINISH:
      setIsRedirecting(true)
      return null;

    default:
      return null
  }
};
